import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class PanelDashboardComponent implements OnInit {
  

  
  constructor() {}

  ngOnInit(): void {
    
  }



}
